import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Category',
    value: 'categoryName',
  },
  {
    label: 'Item',
    value: 'itemName',
  },
  {
    label: 'Unit',
    value: 'unit',
  },
  {
    label: 'MH price',
    value: 'pricesss',
  },
  {
    label: 'HH Price',
    value: 'hhPrice',
  },
  {
    label: 'Currency',
    value: 'currency',
  },
  {
    label: 'Benefit',
    value: 'benefitName',
  },
  {
    label: 'My trips',
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
